import React from 'react';
import ContMessageI18N from '../../containers/ContMessageI18N';
import NumberFormatCustom from '../std/NumberFormatCustom';
import HelperEnv from '../../helpers/HelperEnv';
import HelperWidget from '../../helpers/HelperWidget';
import ContFinanceFileSetting from '../../containers/ContFinanceFileSetting'
import DocIntegration from './DocIntegration'
import DocDemo from './DocDemo'
import DocIntegrationWidSFS from './DocIntegrationWidSFS';
import FastPlugCurrentDateInput from './FastPlugCurrentDateInput';
import {format} from 'date-fns';

class TestSetting extends React.Component {

  handleChangeAmountNature = name => event => {
    var newValue = event.target.value;
    this.props.onChangeAmountNature(newValue);
  };
  handleChangeLangage = name => event => {
    var newValue = event.target.value;
    this.props.onChangeLanguage(newValue, this.props.context.languageCode);
  };
  handleChangeProcess = name => event => {
    var newValue = event.target.value;
    this.props.onChangeProcess(newValue);
  };
  handleChangePerimeterFilter = name => event => {
    const newValue = event.target.value;
    this.props.onChangePerimeterFilter(newValue, this.props.settings.vehDescType);
  }
  handleChangeWidgetType = name => event => {
    const newValue = event.target.value;
    const widgetSFS = document.getElementById('widget-sfs');
    if (newValue === 'WIDSFSPLAIN') {
      widgetSFS.style.display = 'block';
    } else {
      widgetSFS.style.display = 'none';
    }
    this.props.onChangeWidgetType(newValue);
  }
  handleChangeNetworkZone = name => event => {
    const newValueCode = event.target.value;
    const newValue = HelperEnv.getEnvNetworkZone(newValueCode);
    this.props.onChangeNetworkZone(newValue);
  }
  handleChangeZIndex = name => event => {
    const newValue = event.target.value;
    this.props.onChangeZIndex(newValue);
    HelperWidget.getInstanceWidgetReloadFunction({ ...this.props.settings, zindex: newValue }, () => { })();
  }
  handleFinanceFileResource = name => event => {
    this.props.onChangeFinanceFileResource(event.target.value);
  }
  handleChangeCheck = name => event => {
    var newValue = event.target.checked;
    if (name === 'developperView') {
      this.props.onChangeDevelopperView(newValue);
    } else if (name === 'isFinanceFile') {
      this.props.onChangeFinanceFile(newValue);
    } else if (name === 'isTestCalculator') {
      this.props.onChangeTestCalculator(newValue);
    } else if (name === 'fastPlugCurrentDate') {
      this.onChangeFastPlugCurrentDate(event);
    }
  }
  handleChangeVehicleExample = name => event => {
    var selection = event.target.value;
    if (selection.length > 0) {
      var selectionObj = JSON.parse(selection);
      this.props.onChangeVehicleExample(selectionObj);
    }
  }
  onChangeFastPlugCurrentDate(event) {
    if (event.target.value !== null && event.target.value !== undefined && event.target.value.length > 0) {
      var date = new Date(event.target.value);
      date.setHours(0, 0, 0);
      this.props.settings.fastPlugCurrentDate = format(date, "yyyy-MM-dd'T'HH:mm:ss");
    } else {
      this.props.settings.fastPlugCurrentDate = undefined;
    }
  }

  handleLoadVehicleExamples() {
    if (this.props.settings.vehicleExamples != null && Object.keys(this.props.settings.vehicleExamples).length > 0) {
      this.props.onLoadVehicleExamples(this.props.settings.vehicleExamples, this.props.settings.process);
    }
  }

  getMessage(i18nKey, optionValue) { return <ContMessageI18N i18n={i18nKey} optionValue={optionValue} /> }

  render() {
    const languages = ['xx', 'fr', 'en'];
    return (
      <React.Fragment>
        <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
          <div className="offcanvas-header">
            Settings
            <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div className="offcanvas-body">
            {this.renderDocumentationPart()}
            <div className="list-group list-group-flush">
              <div className="list-group-item text-light bg-primary form-floating border-0">
                <select className="form-select text-light bg-primary" id="head-select-language"
                  onChange={this.handleChangeLangage('language')} value={this.props.settings.language}>
                  {languages.map((language, index) => (
                    <React.Fragment key={index}>{this.getMessage(`testpage.header.language.${language}`, language)}</React.Fragment>
                  ))}
                </select>
                <label htmlFor="head-select-language" className="labelSettingSelect">&nbsp;&nbsp;{this.getMessage('testpage.header.language')}</label>
              </div>
              <div className="list-group-item text-light bg-primary form-floating border-0">
                <select className="form-select text-light bg-primary" id="head-select-process"
                  onChange={this.handleChangeProcess('process')} value={this.props.settings.process}>
                  <React.Fragment >{this.getMessage('testpage.header.process.basket', 'basket')}</React.Fragment>
                  <React.Fragment >{this.getMessage('testpage.header.process.summary', 'summary')}</React.Fragment>
                  <React.Fragment >{this.getMessage('testpage.header.process.options', 'options')}</React.Fragment>
                  <React.Fragment >{this.getMessage('testpage.header.process.accessories', 'accessories')}</React.Fragment>
                  {this.props.settings.vehDescType === 'MANUFACTURER'
                    && <React.Fragment >{this.getMessage('testpage.header.process.vehiclesConfig', 'vehiclesConfig')}</React.Fragment>
                  }
                  <React.Fragment >{this.getMessage('testpage.header.process.vehiclesStock', 'vehiclesStock')}</React.Fragment>
                  <React.Fragment >{this.getMessage('testpage.header.process.vehiclesDefault', 'vehiclesDefault')}</React.Fragment>
                  
                </select>
                <label htmlFor="head-select-process" className="labelSettingSelect">&nbsp;&nbsp;{this.getMessage('testpage.header.process')}</label>
              </div>
              {HelperEnv.isEnabledTestVehicles(this.props.env) && this.props.settings.process !== 'vehiclesConfig'
                && this.props.settings.process !== 'vehiclesStock' && this.props.settings.process !== 'vehiclesDefault'
                && <div className="list-group-item text-light bg-primary form-floating border-0">
                  <select className="form-select text-light bg-primary" id="head-vehicle-example"
                    onChange={this.handleChangeVehicleExample('vehicleExample')} >
                    <option value=""></option>
                    {this.props.settings.vehicleExamples != null && this.props.settings.vehicleExamples.map != null &&
                      this.props.settings.vehicleExamples.map((record, index) => (
                        <option value={JSON.stringify(record)} key={index}>
                          {(record.presentation && record.presentation.longLabel) || '(no name)'}
                        </option>
                      ))}
                  </select>
                  <label htmlFor="head-vehicle-example" className="labelSettingSelect">&nbsp;&nbsp;{this.getMessage('testpage.header.vehicleExample')}</label>
                </div>
              }
              {(HelperEnv.isEnabledTestVehicles(this.props.env)
                && (this.props.settings.process === 'vehiclesConfig'
                  || this.props.settings.process === 'vehiclesStock' || this.props.settings.process === 'vehiclesDefault'))
                && <div className="list-group-item text-light bg-primary border-0">
                  <button onClick={() => this.handleLoadVehicleExamples()} className="btn btn-dark text-light border">
                    {this.getMessage('testpage.header.vehicleExample.load')}
                  </button>
                </div>
              }
              <div className="list-group-item text-light bg-primary border-0">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value={this.props.settings.isDevelopperView}
                    id="head-developperView" onChange={this.handleChangeCheck('developperView')} />
                  <label className="form-check-label" htmlFor="head-developperView">
                    {this.getMessage('testpage.header.developperView')}
                  </label>
                </div>
              </div>
              <div className="list-group-item text-light bg-primary border-0">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value={this.props.settings.isTestCalculator}
                    id="head-isTestCalculator" onChange={this.handleChangeCheck('isTestCalculator')} />
                  <label className="form-check-label" htmlFor="head-isTestCalculator">
                    {this.getMessage('testpage.header.isTestCalculator')}
                  </label>
                </div>
              </div>
              {HelperEnv.isAuthenticationSet(this.props.env)
                && (this.props.env.isAuthSimu || HelperEnv.getEnabledConditionTestVehicles() === 'authenticated')
                && <div className="list-group-item text-light bg-primary border-0">
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" value={this.props.settings.isFinanceFile}
                      id="head-isFinanceFile" onChange={this.handleChangeCheck('isFinanceFile')} />
                    <label className="form-check-label" htmlFor="head-isFinanceFile">
                      {this.getMessage('testpage.header.isFinanceFile')}
                    </label>
                  </div>
                </div>}
            
              {this.props.settings.isDevelopperView
                && 
                <FastPlugCurrentDateInput
                  onChange={this.handleChangeCheck('fastPlugCurrentDate')}
                  label={this.getMessage('testpage.header.fastPlugCurrentDate')}/>
              }
              <div className="list-group-item text-light bg-primary form-floating border-0">
                <select className="form-select text-light bg-primary" id="head-perimeterFilter"
                  onChange={this.handleChangePerimeterFilter()}
                  value={this.props.settings.perimeterFilter} >
                  <option value="">(no filter)</option>
                  <option value="SFS">SFS - {this.getMessage('testpage.header.perimeterFilter.SFS')}</option>
                  <option value="SCF">SCF - {this.getMessage('testpage.header.perimeterFilter.SCF')}</option>
                </select>
                <label htmlFor="head-perimeterFilter" className="labelSettingSelect">&nbsp;&nbsp;{this.getMessage('testpage.header.perimeterFilter')}</label>
              </div>
              <div className="list-group-item text-light bg-primary form-floating border-0">
                <select className="form-select text-light bg-primary" id="head-widgetType"
                  onChange={this.handleChangeWidgetType()}
                  value={this.props.settings.widgetType} >
                  <option value="WIDBPF">{this.getMessage('testpage.header.widgetType.WIDBPF')}</option>
                  <option value="WIDSFSPLAIN">{this.getMessage('testpage.header.widgetType.WIDSFSPLAIN')}</option>
                  <option value="WIDSFSSIDE">{this.getMessage('testpage.header.widgetType.WIDSFSSIDE')}</option>
                  <option value="WIDSFSMODAL">{this.getMessage('testpage.header.widgetType.WIDSFSMODAL')}</option>
                </select>
                <label htmlFor="head-widgetType" className="labelSettingSelect">&nbsp;&nbsp;{this.getMessage('testpage.header.widgetType')}</label>
              </div>
              {this.props.settings.isDevelopperView
                && <div className="list-group-item bg-primary border-0">
                  <div className="col-auto form-floating">
                    <NumberFormatCustom id='zindex' className="form-control"
                      placeholder={this.getMessage('testpage.header.zindex')}
                      value={this.props.settings.zindex} onChange={this.handleChangeZIndex()} />
                    <label htmlFor='zindex'>{this.getMessage('testpage.header.zindex')}</label>
                  </div>
                </div>
              }
              {HelperEnv.isAuthenticationSet(this.props.env)
                && <React.Fragment>
                  <div className="list-group-item text-light bg-primary form-floating border-0">
                    <select className="form-select text-light bg-primary" id="head-networkzone"
                      onChange={this.handleChangeNetworkZone()} >
                      {HelperEnv.getEnvNetworkZones().map((record, index) => (
                        <option value={record.code} key={index}>
                          {this.getMessage(`testpage.header.networkZone.${record.code}`)}
                        </option>
                      ))}
                    </select>
                    <label htmlFor="head-financeFileResource" className="labelSettingSelect">&nbsp;&nbsp;{this.getMessage('testpage.header.financeFileResource')}</label>
                  </div>
                  <div className="list-group-item text-light bg-primary form-floating border-0">
                    <select className="form-select text-light bg-primary" id="head-financeFileResource"
                      onChange={this.handleFinanceFileResource()} >
                      <option value='FINFILE' >{this.getMessage('testpage.header.financeFileResource.FINFILE')}</option>
                      <option value='QUOTATION' >{this.getMessage('testpage.header.financeFileResource.QUOTATION')}</option>
                    </select>
                    <label htmlFor="head-financeFileResource" className="labelSettingSelect">&nbsp;&nbsp;{this.getMessage('testpage.header.financeFileResource')}</label>
                  </div>
                </React.Fragment>
              }
              <div className="list-group-item text-light bg-primary border-0">
                <button data-bs-toggle="modal" data-bs-target="#authentModal" className="btn btn-dark border" >
                  {this.getMessage('testpage.header.basic.params')}
                </button>
              </div>
            </div>
          </div>
        </div>
        < ContFinanceFileSetting />
        < DocIntegration />
        < DocDemo />
        < DocIntegrationWidSFS />
      </React.Fragment >
    );
  }

  renderDocumentationPart() {
    return (<React.Fragment>
      {(HelperEnv.isEnableDoc() === 'true') &&
        <div className="accordion" id="accordionDemos">
          <div className="accordion-item">
            <h6 className="accordion-header" id="headingDemos" >
              <button className="accordion-button" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseDemoNative" aria-expanded="false" aria-controls="collapseDemoNative">
                {this.getMessage('testpage.header.integration')}
              </button>
            </h6>
            {this.renderDocumentationPartLink('modalDocIntegration', 'testpage.header.integration.widgetsimu')}
            {this.renderDocumentationPartLink('modalDocDemo', 'testpage.header.integration.widgetsimu.nativejs')}
            {this.renderDocumentationPartLink('modalDocWidSFS', 'testpage.header.integration.widgetSFS')}
          </div>
        </div>
      }
    </React.Fragment>);
  }

  renderDocumentationPartLink(target, i18nKey) {
    return (
      <div id="collapseDemoNative" className="accordion-collapse collapse" aria-labelledby="headingDemos"
        data-bs-parent="#accordionDemos">
        <div className="accordion-body p-0">
          <button type="button" className="btn btn-link" data-bs-toggle="modal" data-bs-target={`#${target}`}>
            {this.getMessage(i18nKey)}
          </button>
        </div>
      </div>
    );
  }

}

export default (TestSetting);
